import { render, staticRenderFns } from "./VehicleBrandManage.vue?vue&type=template&id=3d426994&scoped=true"
import script from "./VehicleBrandManage.vue?vue&type=script&lang=js"
export * from "./VehicleBrandManage.vue?vue&type=script&lang=js"
import style0 from "./VehicleBrandManage.vue?vue&type=style&index=0&id=3d426994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d426994",
  null
  
)

export default component.exports